import CurriculumCatalogWindow from "./CurriculumCatalogWindow";

export default CurriculumCatalogWindow;